// src/quiz/gre-mock3/index.js
// GRE Mock 3 — props for the shared Gre_verbal / Gre_quantitative /
// Gre_analytical components. Test names end in "Mock 3" so the profile
// keeps these results apart from the other mocks.
import verbalQuestions from "./verbalData";
import { section1Questions, section2Questions } from "./quantitativeData";

export const greMock3 = {
  verbal: {
    questions: verbalQuestions,
    testName: "GRE Verbal Reasoning Mock 3",
    title: "GRE Verbal Reasoning — Mock 3",
  },
  quantitative: {
    section1: section1Questions,
    section2: section2Questions,
    testName: "GRE Quantitative Reasoning Mock 3",
    title: "GRE Quantitative Reasoning — Mock 3",
  },
  analytical: {
    testName: "GRE Analytical Writing Mock 3",
    title: "GRE Analytical — Mock 3",
    prompt:
      "\"Leaders are most effective when they are willing to change their positions in response to new evidence, even at the risk of appearing inconsistent.\"",
    directions:
      "Write a response in which you discuss the extent to which you agree or disagree with the claim. In developing and supporting your position, be sure to address the most compelling reasons and/or examples that could be used to challenge your position.",
    topicKeywords: [
      "leader", "change", "position", "evidence", "consisten", "flexib",
      "decision", "adapt", "credib", "trust", "revers", "effective",
    ],
  },
};
